import Link from "next/link";
import { Table, Tag, Space, Skeleton } from "antd";
import { useQuery } from "react-query";
import { apiAxios } from "../../services/HttpServices";
import * as ROUTES from "constants/routes";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id) => (
      <Link href={ROUTES.STAFF_DETAIL} as={`/staff/${id}`}>
        <a>{id}</a>
      </Link>
    ),
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    key: "role",
    dataIndex: "role",
    render: (role) => (
      <>
        {role === "admin" ? (
          <Tag color="blue">{role.toUpperCase()}</Tag>
        ) : (
          <Tag color="green">{role.toUpperCase()}</Tag>
        )}
      </>
    ),
  },
];

async function fetcher() {
  const res = await apiAxios.get("/users");
  return { staff: res.data?.data || null };
}

function AllStaff() {
  const { status, data, error } = useQuery("all-staff", fetcher);
  if (status === "loading") {
    return <Skeleton />;
  }

  if (error) {
    return "Error";
  }

  return (
    <Table
      columns={columns}
      dataSource={data.staff}
      rowKey={(staff) => staff.id}
    />
  );
}

export default AllStaff;
